import { Navigate, useParams } from 'react-router-dom'

const CardapioLegadoPage = () => {
  const { idestabelecimento } = useParams()

  return <Navigate to={`/estabelecimento/${idestabelecimento}/cardapio`} />
}

export default CardapioLegadoPage
